/* tslint:disable */
/* eslint-disable */
/**
 * Taktile SDK API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface InitBundleResponse
 */
export interface InitBundleResponse {
    /**
     * 
     * @type {string}
     * @memberof InitBundleResponse
     */
    'bundleId': string;
}
/**
 * 
 * @export
 * @interface ProviderSdkBundleDBCreate
 */
export interface ProviderSdkBundleDBCreate {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleDBCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleDBCreate
     */
    'slug': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProviderSdkBundleDBCreate
     */
    'config_ids': Array<string>;
}
/**
 * Update payload.  `slug` is locked at creation; only `name` and `config_ids` are editable.
 * @export
 * @interface ProviderSdkBundleDBUpdate
 */
export interface ProviderSdkBundleDBUpdate {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleDBUpdate
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProviderSdkBundleDBUpdate
     */
    'config_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface ProviderSdkBundleListResponse
 */
export interface ProviderSdkBundleListResponse {
    /**
     * 
     * @type {Array<ProviderSdkBundleResponse>}
     * @memberof ProviderSdkBundleListResponse
     */
    'data': Array<ProviderSdkBundleResponse>;
}
/**
 * Hydrated wire shape: configs expanded inline so the frontend can render the bundle\'s attached configurations without a follow-up request.
 * @export
 * @interface ProviderSdkBundleResponse
 */
export interface ProviderSdkBundleResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleResponse
     */
    'slug': string;
    /**
     * 
     * @type {Array<ProviderSdkConfigResponse>}
     * @memberof ProviderSdkBundleResponse
     */
    'configs': Array<ProviderSdkConfigResponse>;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundleResponse
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ProviderSdkCatalogEntry
 */
export interface ProviderSdkCatalogEntry {
    /**
     * 
     * @type {SdkProvider}
     * @memberof ProviderSdkCatalogEntry
     */
    'provider': SdkProvider;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkCatalogEntry
     */
    'provider_sdk_version': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkCatalogEntry
     */
    'icon_path': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProviderSdkCatalogEntry
     */
    'config_schema': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProviderSdkCatalogEntry
     */
    'sample_configuration': { [key: string]: any; } | null;
}


/**
 * 
 * @export
 * @interface ProviderSdkCatalogResponse
 */
export interface ProviderSdkCatalogResponse {
    /**
     * 
     * @type {Array<ProviderSdkCatalogEntry>}
     * @memberof ProviderSdkCatalogResponse
     */
    'data': Array<ProviderSdkCatalogEntry>;
}
/**
 * 
 * @export
 * @interface ProviderSdkConfigDBCreate
 */
export interface ProviderSdkConfigDBCreate {
    /**
     * 
     * @type {SdkProvider}
     * @memberof ProviderSdkConfigDBCreate
     */
    'provider': SdkProvider;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigDBCreate
     */
    'provider_sdk_version': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProviderSdkConfigDBCreate
     */
    'configuration': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigDBCreate
     */
    'name': string;
}


/**
 * Update payload.  `provider` and `provider_sdk_version` are locked at creation; only `name` and `configuration` are editable. Configuration is validated against the existing record\'s provider/version in the repo, not here.
 * @export
 * @interface ProviderSdkConfigDBUpdate
 */
export interface ProviderSdkConfigDBUpdate {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigDBUpdate
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProviderSdkConfigDBUpdate
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProviderSdkConfigListResponse
 */
export interface ProviderSdkConfigListResponse {
    /**
     * 
     * @type {Array<ProviderSdkConfigResponse>}
     * @memberof ProviderSdkConfigListResponse
     */
    'data': Array<ProviderSdkConfigResponse>;
}
/**
 * 
 * @export
 * @interface ProviderSdkConfigResponse
 */
export interface ProviderSdkConfigResponse {
    /**
     * 
     * @type {SdkProvider}
     * @memberof ProviderSdkConfigResponse
     */
    'provider': SdkProvider;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'provider_sdk_version': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProviderSdkConfigResponse
     */
    'configuration': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'icon_path': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkConfigResponse
     */
    'updated_at': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum SdkProvider {
    FINGERPRINT = 'fingerprint',
    SOCURE = 'socure'
}


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * ProviderSdkApi - axios parameter creator
 * @export
 */
export const ProviderSdkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Provider Sdk Config
         * @param {ProviderSdkConfigDBCreate} providerSdkConfigDBCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSdkConfig: async (providerSdkConfigDBCreate: ProviderSdkConfigDBCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkConfigDBCreate' is not null or undefined
            assertParamExists('createProviderSdkConfig', 'providerSdkConfigDBCreate', providerSdkConfigDBCreate)
            const localVarPath = `/sdk/api/v1/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSdkConfigDBCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderSdkConfig: async (providerSdkConfigId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkConfigId' is not null or undefined
            assertParamExists('deleteProviderSdkConfig', 'providerSdkConfigId', providerSdkConfigId)
            const localVarPath = `/sdk/api/v1/configs/{provider_sdk_config_id}`
                .replace(`{${"provider_sdk_config_id"}}`, encodeURIComponent(String(providerSdkConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns every available SDK provider/version with its configuration schema (form dialect) and a sample configuration.
         * @summary Get Provider Sdk Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkCatalog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sdk/api/v1/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkConfig: async (providerSdkConfigId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkConfigId' is not null or undefined
            assertParamExists('getProviderSdkConfig', 'providerSdkConfigId', providerSdkConfigId)
            const localVarPath = `/sdk/api/v1/configs/{provider_sdk_config_id}`
                .replace(`{${"provider_sdk_config_id"}}`, encodeURIComponent(String(providerSdkConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Provider Sdk Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderSdkConfigs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sdk/api/v1/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {ProviderSdkConfigDBUpdate} providerSdkConfigDBUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderSdkConfig: async (providerSdkConfigId: string, providerSdkConfigDBUpdate: ProviderSdkConfigDBUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkConfigId' is not null or undefined
            assertParamExists('updateProviderSdkConfig', 'providerSdkConfigId', providerSdkConfigId)
            // verify required parameter 'providerSdkConfigDBUpdate' is not null or undefined
            assertParamExists('updateProviderSdkConfig', 'providerSdkConfigDBUpdate', providerSdkConfigDBUpdate)
            const localVarPath = `/sdk/api/v1/configs/{provider_sdk_config_id}`
                .replace(`{${"provider_sdk_config_id"}}`, encodeURIComponent(String(providerSdkConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSdkConfigDBUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderSdkApi - functional programming interface
 * @export
 */
export const ProviderSdkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderSdkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Provider Sdk Config
         * @param {ProviderSdkConfigDBCreate} providerSdkConfigDBCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderSdkConfig(providerSdkConfigDBCreate: ProviderSdkConfigDBCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderSdkConfig(providerSdkConfigDBCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.createProviderSdkConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProviderSdkConfig(providerSdkConfigId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProviderSdkConfig(providerSdkConfigId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.deleteProviderSdkConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns every available SDK provider/version with its configuration schema (form dialect) and a sample configuration.
         * @summary Get Provider Sdk Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderSdkCatalog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderSdkCatalog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.getProviderSdkCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderSdkConfig(providerSdkConfigId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderSdkConfig(providerSdkConfigId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.getProviderSdkConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Provider Sdk Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProviderSdkConfigs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkConfigListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProviderSdkConfigs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.listProviderSdkConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Provider Sdk Config
         * @param {string} providerSdkConfigId 
         * @param {ProviderSdkConfigDBUpdate} providerSdkConfigDBUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderSdkConfig(providerSdkConfigId: string, providerSdkConfigDBUpdate: ProviderSdkConfigDBUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderSdkConfig(providerSdkConfigId, providerSdkConfigDBUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkApi.updateProviderSdkConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderSdkApi - factory interface
 * @export
 */
export const ProviderSdkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderSdkApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Provider Sdk Config
         * @param {ProviderSdkApiCreateProviderSdkConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSdkConfig(requestParameters: ProviderSdkApiCreateProviderSdkConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkConfigResponse> {
            return localVarFp.createProviderSdkConfig(requestParameters.providerSdkConfigDBCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Provider Sdk Config
         * @param {ProviderSdkApiDeleteProviderSdkConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderSdkConfig(requestParameters: ProviderSdkApiDeleteProviderSdkConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProviderSdkConfig(requestParameters.providerSdkConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns every available SDK provider/version with its configuration schema (form dialect) and a sample configuration.
         * @summary Get Provider Sdk Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkCatalog(options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkCatalogResponse> {
            return localVarFp.getProviderSdkCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Sdk Config
         * @param {ProviderSdkApiGetProviderSdkConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkConfig(requestParameters: ProviderSdkApiGetProviderSdkConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkConfigResponse> {
            return localVarFp.getProviderSdkConfig(requestParameters.providerSdkConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Provider Sdk Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderSdkConfigs(options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkConfigListResponse> {
            return localVarFp.listProviderSdkConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Provider Sdk Config
         * @param {ProviderSdkApiUpdateProviderSdkConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderSdkConfig(requestParameters: ProviderSdkApiUpdateProviderSdkConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkConfigResponse> {
            return localVarFp.updateProviderSdkConfig(requestParameters.providerSdkConfigId, requestParameters.providerSdkConfigDBUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProviderSdkConfig operation in ProviderSdkApi.
 * @export
 * @interface ProviderSdkApiCreateProviderSdkConfigRequest
 */
export interface ProviderSdkApiCreateProviderSdkConfigRequest {
    /**
     * 
     * @type {ProviderSdkConfigDBCreate}
     * @memberof ProviderSdkApiCreateProviderSdkConfig
     */
    readonly providerSdkConfigDBCreate: ProviderSdkConfigDBCreate
}

/**
 * Request parameters for deleteProviderSdkConfig operation in ProviderSdkApi.
 * @export
 * @interface ProviderSdkApiDeleteProviderSdkConfigRequest
 */
export interface ProviderSdkApiDeleteProviderSdkConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkApiDeleteProviderSdkConfig
     */
    readonly providerSdkConfigId: string
}

/**
 * Request parameters for getProviderSdkConfig operation in ProviderSdkApi.
 * @export
 * @interface ProviderSdkApiGetProviderSdkConfigRequest
 */
export interface ProviderSdkApiGetProviderSdkConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkApiGetProviderSdkConfig
     */
    readonly providerSdkConfigId: string
}

/**
 * Request parameters for updateProviderSdkConfig operation in ProviderSdkApi.
 * @export
 * @interface ProviderSdkApiUpdateProviderSdkConfigRequest
 */
export interface ProviderSdkApiUpdateProviderSdkConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkApiUpdateProviderSdkConfig
     */
    readonly providerSdkConfigId: string

    /**
     * 
     * @type {ProviderSdkConfigDBUpdate}
     * @memberof ProviderSdkApiUpdateProviderSdkConfig
     */
    readonly providerSdkConfigDBUpdate: ProviderSdkConfigDBUpdate
}

/**
 * ProviderSdkApi - object-oriented interface
 * @export
 * @class ProviderSdkApi
 * @extends {BaseAPI}
 */
export class ProviderSdkApi extends BaseAPI {
    /**
     * 
     * @summary Create Provider Sdk Config
     * @param {ProviderSdkApiCreateProviderSdkConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public createProviderSdkConfig(requestParameters: ProviderSdkApiCreateProviderSdkConfigRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).createProviderSdkConfig(requestParameters.providerSdkConfigDBCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Provider Sdk Config
     * @param {ProviderSdkApiDeleteProviderSdkConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public deleteProviderSdkConfig(requestParameters: ProviderSdkApiDeleteProviderSdkConfigRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).deleteProviderSdkConfig(requestParameters.providerSdkConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns every available SDK provider/version with its configuration schema (form dialect) and a sample configuration.
     * @summary Get Provider Sdk Catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public getProviderSdkCatalog(options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).getProviderSdkCatalog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Sdk Config
     * @param {ProviderSdkApiGetProviderSdkConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public getProviderSdkConfig(requestParameters: ProviderSdkApiGetProviderSdkConfigRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).getProviderSdkConfig(requestParameters.providerSdkConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Provider Sdk Configs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public listProviderSdkConfigs(options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).listProviderSdkConfigs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Provider Sdk Config
     * @param {ProviderSdkApiUpdateProviderSdkConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkApi
     */
    public updateProviderSdkConfig(requestParameters: ProviderSdkApiUpdateProviderSdkConfigRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkApiFp(this.configuration).updateProviderSdkConfig(requestParameters.providerSdkConfigId, requestParameters.providerSdkConfigDBUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderSdkBundlesApi - axios parameter creator
 * @export
 */
export const ProviderSdkBundlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Provider Sdk Bundle
         * @param {ProviderSdkBundleDBCreate} providerSdkBundleDBCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSdkBundle: async (providerSdkBundleDBCreate: ProviderSdkBundleDBCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkBundleDBCreate' is not null or undefined
            assertParamExists('createProviderSdkBundle', 'providerSdkBundleDBCreate', providerSdkBundleDBCreate)
            const localVarPath = `/sdk/api/v1/bundles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSdkBundleDBCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderSdkBundle: async (providerSdkBundleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkBundleId' is not null or undefined
            assertParamExists('deleteProviderSdkBundle', 'providerSdkBundleId', providerSdkBundleId)
            const localVarPath = `/sdk/api/v1/bundles/{provider_sdk_bundle_id}`
                .replace(`{${"provider_sdk_bundle_id"}}`, encodeURIComponent(String(providerSdkBundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkBundle: async (providerSdkBundleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkBundleId' is not null or undefined
            assertParamExists('getProviderSdkBundle', 'providerSdkBundleId', providerSdkBundleId)
            const localVarPath = `/sdk/api/v1/bundles/{provider_sdk_bundle_id}`
                .replace(`{${"provider_sdk_bundle_id"}}`, encodeURIComponent(String(providerSdkBundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init Provider Sdk Bundle
         * @param {string} bundleSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initProviderSdkBundle: async (bundleSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleSlug' is not null or undefined
            assertParamExists('initProviderSdkBundle', 'bundleSlug', bundleSlug)
            const localVarPath = `/sdk/api/v1/bundles/{bundle_slug}/init`
                .replace(`{${"bundle_slug"}}`, encodeURIComponent(String(bundleSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Provider Sdk Bundles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderSdkBundles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sdk/api/v1/bundles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {ProviderSdkBundleDBUpdate} providerSdkBundleDBUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderSdkBundle: async (providerSdkBundleId: string, providerSdkBundleDBUpdate: ProviderSdkBundleDBUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSdkBundleId' is not null or undefined
            assertParamExists('updateProviderSdkBundle', 'providerSdkBundleId', providerSdkBundleId)
            // verify required parameter 'providerSdkBundleDBUpdate' is not null or undefined
            assertParamExists('updateProviderSdkBundle', 'providerSdkBundleDBUpdate', providerSdkBundleDBUpdate)
            const localVarPath = `/sdk/api/v1/bundles/{provider_sdk_bundle_id}`
                .replace(`{${"provider_sdk_bundle_id"}}`, encodeURIComponent(String(providerSdkBundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSdkBundleDBUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderSdkBundlesApi - functional programming interface
 * @export
 */
export const ProviderSdkBundlesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderSdkBundlesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Provider Sdk Bundle
         * @param {ProviderSdkBundleDBCreate} providerSdkBundleDBCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderSdkBundle(providerSdkBundleDBCreate: ProviderSdkBundleDBCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderSdkBundle(providerSdkBundleDBCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.createProviderSdkBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProviderSdkBundle(providerSdkBundleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProviderSdkBundle(providerSdkBundleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.deleteProviderSdkBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderSdkBundle(providerSdkBundleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderSdkBundle(providerSdkBundleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.getProviderSdkBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Init Provider Sdk Bundle
         * @param {string} bundleSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initProviderSdkBundle(bundleSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initProviderSdkBundle(bundleSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.initProviderSdkBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Provider Sdk Bundles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProviderSdkBundles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkBundleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProviderSdkBundles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.listProviderSdkBundles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Provider Sdk Bundle
         * @param {string} providerSdkBundleId 
         * @param {ProviderSdkBundleDBUpdate} providerSdkBundleDBUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderSdkBundle(providerSdkBundleId: string, providerSdkBundleDBUpdate: ProviderSdkBundleDBUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderSdkBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderSdkBundle(providerSdkBundleId, providerSdkBundleDBUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSdkBundlesApi.updateProviderSdkBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderSdkBundlesApi - factory interface
 * @export
 */
export const ProviderSdkBundlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderSdkBundlesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Provider Sdk Bundle
         * @param {ProviderSdkBundlesApiCreateProviderSdkBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSdkBundle(requestParameters: ProviderSdkBundlesApiCreateProviderSdkBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkBundleResponse> {
            return localVarFp.createProviderSdkBundle(requestParameters.providerSdkBundleDBCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Provider Sdk Bundle
         * @param {ProviderSdkBundlesApiDeleteProviderSdkBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderSdkBundle(requestParameters: ProviderSdkBundlesApiDeleteProviderSdkBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProviderSdkBundle(requestParameters.providerSdkBundleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Sdk Bundle
         * @param {ProviderSdkBundlesApiGetProviderSdkBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSdkBundle(requestParameters: ProviderSdkBundlesApiGetProviderSdkBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkBundleResponse> {
            return localVarFp.getProviderSdkBundle(requestParameters.providerSdkBundleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init Provider Sdk Bundle
         * @param {ProviderSdkBundlesApiInitProviderSdkBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initProviderSdkBundle(requestParameters: ProviderSdkBundlesApiInitProviderSdkBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<InitBundleResponse> {
            return localVarFp.initProviderSdkBundle(requestParameters.bundleSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Provider Sdk Bundles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderSdkBundles(options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkBundleListResponse> {
            return localVarFp.listProviderSdkBundles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Provider Sdk Bundle
         * @param {ProviderSdkBundlesApiUpdateProviderSdkBundleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderSdkBundle(requestParameters: ProviderSdkBundlesApiUpdateProviderSdkBundleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderSdkBundleResponse> {
            return localVarFp.updateProviderSdkBundle(requestParameters.providerSdkBundleId, requestParameters.providerSdkBundleDBUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProviderSdkBundle operation in ProviderSdkBundlesApi.
 * @export
 * @interface ProviderSdkBundlesApiCreateProviderSdkBundleRequest
 */
export interface ProviderSdkBundlesApiCreateProviderSdkBundleRequest {
    /**
     * 
     * @type {ProviderSdkBundleDBCreate}
     * @memberof ProviderSdkBundlesApiCreateProviderSdkBundle
     */
    readonly providerSdkBundleDBCreate: ProviderSdkBundleDBCreate
}

/**
 * Request parameters for deleteProviderSdkBundle operation in ProviderSdkBundlesApi.
 * @export
 * @interface ProviderSdkBundlesApiDeleteProviderSdkBundleRequest
 */
export interface ProviderSdkBundlesApiDeleteProviderSdkBundleRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundlesApiDeleteProviderSdkBundle
     */
    readonly providerSdkBundleId: string
}

/**
 * Request parameters for getProviderSdkBundle operation in ProviderSdkBundlesApi.
 * @export
 * @interface ProviderSdkBundlesApiGetProviderSdkBundleRequest
 */
export interface ProviderSdkBundlesApiGetProviderSdkBundleRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundlesApiGetProviderSdkBundle
     */
    readonly providerSdkBundleId: string
}

/**
 * Request parameters for initProviderSdkBundle operation in ProviderSdkBundlesApi.
 * @export
 * @interface ProviderSdkBundlesApiInitProviderSdkBundleRequest
 */
export interface ProviderSdkBundlesApiInitProviderSdkBundleRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundlesApiInitProviderSdkBundle
     */
    readonly bundleSlug: string
}

/**
 * Request parameters for updateProviderSdkBundle operation in ProviderSdkBundlesApi.
 * @export
 * @interface ProviderSdkBundlesApiUpdateProviderSdkBundleRequest
 */
export interface ProviderSdkBundlesApiUpdateProviderSdkBundleRequest {
    /**
     * 
     * @type {string}
     * @memberof ProviderSdkBundlesApiUpdateProviderSdkBundle
     */
    readonly providerSdkBundleId: string

    /**
     * 
     * @type {ProviderSdkBundleDBUpdate}
     * @memberof ProviderSdkBundlesApiUpdateProviderSdkBundle
     */
    readonly providerSdkBundleDBUpdate: ProviderSdkBundleDBUpdate
}

/**
 * ProviderSdkBundlesApi - object-oriented interface
 * @export
 * @class ProviderSdkBundlesApi
 * @extends {BaseAPI}
 */
export class ProviderSdkBundlesApi extends BaseAPI {
    /**
     * 
     * @summary Create Provider Sdk Bundle
     * @param {ProviderSdkBundlesApiCreateProviderSdkBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public createProviderSdkBundle(requestParameters: ProviderSdkBundlesApiCreateProviderSdkBundleRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).createProviderSdkBundle(requestParameters.providerSdkBundleDBCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Provider Sdk Bundle
     * @param {ProviderSdkBundlesApiDeleteProviderSdkBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public deleteProviderSdkBundle(requestParameters: ProviderSdkBundlesApiDeleteProviderSdkBundleRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).deleteProviderSdkBundle(requestParameters.providerSdkBundleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Sdk Bundle
     * @param {ProviderSdkBundlesApiGetProviderSdkBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public getProviderSdkBundle(requestParameters: ProviderSdkBundlesApiGetProviderSdkBundleRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).getProviderSdkBundle(requestParameters.providerSdkBundleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init Provider Sdk Bundle
     * @param {ProviderSdkBundlesApiInitProviderSdkBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public initProviderSdkBundle(requestParameters: ProviderSdkBundlesApiInitProviderSdkBundleRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).initProviderSdkBundle(requestParameters.bundleSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Provider Sdk Bundles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public listProviderSdkBundles(options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).listProviderSdkBundles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Provider Sdk Bundle
     * @param {ProviderSdkBundlesApiUpdateProviderSdkBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSdkBundlesApi
     */
    public updateProviderSdkBundle(requestParameters: ProviderSdkBundlesApiUpdateProviderSdkBundleRequest, options?: RawAxiosRequestConfig) {
        return ProviderSdkBundlesApiFp(this.configuration).updateProviderSdkBundle(requestParameters.providerSdkBundleId, requestParameters.providerSdkBundleDBUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



